import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Params} from '@angular/router';
import {NgWizardService} from 'ng-wizard';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {SearchRequestService} from '../../../../shared/service/search-request.service';
import {PaymentSearchModel} from '../../../../shared/dto/payment-search.model';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss']
})
export class PaymentInfoComponent implements OnInit {
  public requestId: number;
  public model =  new PaymentSearchModel;
  public paymentForm: FormGroup;

  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              private spinnerService: NgxUiLoaderService,
              private requestSearchService: SearchRequestService) { }

  ngOnInit() {
    this.paymentForm = new FormGroup({
      refNo: new FormControl(null),
      category: new FormControl(null),
    });
    this.onGetIdFromUrl();
    this.getPaymentDetails();
  }

  onGetIdFromUrl() {
    this.route.params.subscribe(
      (param: Params) => {
        this.requestId = param.requestId;
      }
    );
  }

  getPaymentDetails() {
    this.requestSearchService.getPaymentDetails(this.requestId).subscribe(
      (data: PaymentSearchModel) => {
        this.model = data;
        console.log(data);
      }
    )
  }

}
